module.exports = __webpack_public_path__ + "static/img/evaluation_login.472ef0dc.png";